import { render, staticRenderFns } from "./co-applicants-info.vue?vue&type=template&id=667c8dba"
import script from "./co-applicants-info.vue?vue&type=script&lang=js"
export * from "./co-applicants-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports